import { apiRequest } from '@scc/lib'
import type {
  ShareLinkRepository, ShareLinkSummary, ShareLinkView, ShareLinkFilter, ShareLinkUpdate,
} from '@/data/repositories/types'

const base = (agencyId: number, storeId: number) =>
  `/agencies/${agencyId}/stores/${storeId}/share-links`

function query(filter?: ShareLinkFilter): string {
  const params = new URLSearchParams()
  if (filter?.kind) params.set('kind', filter.kind)
  if (filter?.status && filter.status !== 'all') params.set('status', filter.status)
  const qs = params.toString()
  return qs ? `?${qs}` : ''
}

export function createApiShareLinkRepository(): ShareLinkRepository {
  return {
    list: (agencyId, storeId, filter) =>
      apiRequest<ShareLinkSummary[]>(`${base(agencyId, storeId)}${query(filter)}`),
    listViews: (agencyId, storeId, id) =>
      apiRequest<ShareLinkView[]>(`${base(agencyId, storeId)}/${id}/views`),
    update: (agencyId, storeId, id, patch: ShareLinkUpdate) =>
      apiRequest<ShareLinkSummary>(`${base(agencyId, storeId)}/${id}`, { method: 'PATCH', body: patch }),
    revoke: (agencyId, storeId, id) =>
      apiRequest<ShareLinkSummary>(`${base(agencyId, storeId)}/${id}`, { method: 'DELETE' }),
    purge: async (agencyId, storeId, id) => {
      await apiRequest<void>(`${base(agencyId, storeId)}/${id}?purge=true`, { method: 'DELETE' })
    },
  }
}
